import { jsx } from "react/jsx-runtime";
const QuestionMarkCircle = ({ className = 'tw-text-neutral-light-800', size = 32 })=>/*#__PURE__*/ jsx("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        children: /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm-.333 6.333c-.4 0-.757.138-1 .345-.237.204-.334.444-.334.655a1 1 0 0 1-2 0c0-.85.395-1.627 1.033-2.173.633-.543 1.462-.827 2.3-.827h.667c.839 0 1.668.284 2.301.827.63.54 1.024 1.306 1.033 2.145a3 3 0 0 1-1.94 2.95c-.162.085-.35.262-.5.562a2.36 2.36 0 0 0-.228 1.14 1 1 0 1 1-1.998.085 4.359 4.359 0 0 1 .437-2.12c.321-.642.821-1.19 1.47-1.494a.996.996 0 0 1 .094-.038 1 1 0 0 0 .666-1 .972.972 0 0 1-.001-.057c0-.21-.097-.451-.335-.655a1.546 1.546 0 0 0-.999-.345h-.666ZM13 16.667a1 1 0 1 0-2 0v.006a1 1 0 0 0 2 0v-.006Z",
            fill: "none",
            className: "tw-fill-current"
        })
    });
const QuestionMarkCircle_QuestionMarkCircle = QuestionMarkCircle;
export default QuestionMarkCircle_QuestionMarkCircle;
